import { SearchResponse } from '../types'

// This URL will be configured when the backend is ready
const API_BASE_URL = (import.meta as any).env.VITE_API_BASE_URL || 'http://localhost:8080'

export class SearchService {
  private static async makeRequest<T>(endpoint: string, params?: Record<string, string>): Promise<T> {
    const url = new URL(`${API_BASE_URL}${endpoint}`)
    
    if (params) {
      Object.entries(params).forEach(([key, value]) => {
        url.searchParams.append(key, value)
      })
    }

    const response = await fetch(url.toString(), {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    })

    if (!response.ok) {
      throw new Error(`Search request failed: ${response.status} ${response.statusText}`)
    }

    return response.json()
  }

  static async search(query: string, page: number = 1, limit: number = 10): Promise<SearchResponse> {
    return this.makeRequest<SearchResponse>('/search', {
      q: query,
      page: page.toString(),
      limit: limit.toString(),
    })
  }
}
